(function () {'use strict';}());
angular.module("app").directive('globalHeader', function($document,$timeout,$rootScope) {
    return {
      restrict: 'A',
      templateUrl: 'views/global-header.html',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;
        var faces = ['empty','empty','partial','partial','full','full'];
        var attempts = 0;

        $scope.collectedObjectCount = 0;
        $scope.objectCount = 0;
        $scope.telepathyValue = 5;
        $scope.$watch("currentAdventure",onAdventureChange);
        $scope.$watch("currentPageIndex",onPageChange);
        $scope.$on("telepathy",onTelepathyChange);
        $scope.$on("points",onPointsChange);

        $rootScope.$watch("audioOn",onAudioStateChange);

        $scope.toggleVolume = function(){
            $rootScope.audioOn = !$rootScope.audioOn;
        };

        function onAudioStateChange(value){
          $scope.audioOn = $rootScope.audioOn;
        }        



        function objectCount(){
          var objects = 0;
          $scope.collectedObjectCount = 0;
          if(!$scope.locations || !$scope.currentAdventure) return objects;
          for(var i = 0, count = $scope.locations.length; i < count; i++){
              if($scope.locations[i].artifact) objects++;
              if($scope.locations[i].artifact && $scope.locations[i].artifact.complete) $scope.collectedObjectCount ++;
          }
          return objects;
        }
        function onAdventureChange(val){
            if(!val) return;
            $scope.locations = $scope.currentAdventure.locations;
        }
        function onPageChange(val){
          if(!val || !$scope.currentMinigame) return;
          $scope.objectCount = objectCount();
          initializeTelepathy();
          initializePoints();
        }
        function onTelepathyChange(event,data){
          var initialValue = $scope.telepathyValue;
          $scope.telepathyValue = Math.max(attempts - data,0);
          $scope.face = faces[$scope.telepathyValue];
        }
        function onPointsChange(event,data){
          $scope.pointValue = data;
        }

        function initializePoints(){
          $scope.tp = null;
          var points = $scope.currentMinigame.points;
          if(!points) return;
          $scope.tp = [];
          for(var i = 1; i <= points; i++){
            $scope.tp.push(i);
          }

        }

        function initializeTelepathy(){
          attempts = $scope.currentMinigame.maxattempts || $scope.currentMinigame.maxAttempts;
          switch(attempts){
            case 5:
              faces = ['empty','empty','partial','partial','full','full'];
            break;
            case 3:
              faces = ['empty','empty','partial','full'];
            break;
            default:
          }

          $scope.telepathyValue = attempts;
          $scope.face = faces[$scope.telepathyValue];
          $scope.blocks = [];

          for(var i = 0; i < attempts; i++){
            $scope.blocks.push(i+1);
          }
        }

                           
      }  
    };
  });